import type { Manufacturer } from "../schema/common.js";

export interface ManufacturerInfo {
  name: string;
  /** Primary emissive / trim colour. */
  color: string;
  /** Secondary body colour. */
  accent: string;
  rival: Manufacturer | null;
  tagline: { de: string; en: string };
}

export const MANUFACTURERS: Record<Manufacturer, ManufacturerInfo> = {
  HEX: {
    name: "Hexa Dynamics",
    color: "#E8772E",
    accent: "#3A3F47",
    rival: "RDL",
    tagline: { de: "Schwere Ketten, schwere Geschütze.", en: "Heavy tracks, heavier guns." },
  },
  KRG: {
    name: "Kurogane Works",
    color: "#22D3EE",
    accent: "#F8FAFC",
    rival: "VLK",
    tagline: { de: "Klingen aus Plasma, Beine aus Stahl.", en: "Plasma blades, steel legs." },
  },
  VLK: {
    name: "Valkyr Systems",
    color: "#8B5CF6",
    accent: "#C0C7D1",
    rival: "KRG",
    tagline: { de: "Drei Beine, ein Strahl, kein Entkommen.", en: "Three legs, one beam, no escape." },
  },
  OMC: {
    name: "Orbital Mind Collective",
    color: "#22C55E",
    accent: "#0B0F14",
    rival: null,
    tagline: { de: "Wir reparieren, was ihr zerbrecht.", en: "We repair what you break." },
  },
  RDL: {
    name: "Redline Foundry",
    color: "#EF4444",
    accent: "#7C3A1D",
    rival: "HEX",
    tagline: { de: "Schrott, Sprengstoff, Sieg.", en: "Scrap, explosives, victory." },
  },
};

export const MANUFACTURER_IDS: readonly Manufacturer[] = ["HEX", "KRG", "VLK", "OMC", "RDL"];

export function areRivals(a: Manufacturer, b: Manufacturer): boolean {
  return MANUFACTURERS[a].rival === b;
}
